/**
 * Default report date ranges.
 *
 * Both transactional and performance ranges default to YEAR-TO-DATE: begin =
 * January 1 of the current (latest-data) year, end = the most recent BUSINESS DAY
 * WITH DATA (the lake's MAX as_of_date, via ./lib/reportDates). Historical begin
 * dates now serve real data through the id-seam read-time translation, so a YTD
 * default is meaningful for every report family (it no longer lands on a stale,
 * empty prior year).
 */
import { firstOfDataYear, defaultReportDate } from './lib/reportDates';

/** { start, end } for transactional reports: Jan 1 (data year) .. latest business day. */
export const transactionalDefaultRange = () => ({
  start: firstOfDataYear(),
  end: defaultReportDate(),
});

/** { start, end } for performance reports: Jan 1 (data year) .. latest business day. */
export const performanceDefaultRange = () => ({
  start: firstOfDataYear(),
  end: defaultReportDate(),
});
